module.exports = __webpack_public_path__ + "static/media/ask.e86c90bd.svg";